export const formatCurrency = (amount, currency = 'GHS', locale = 'en-GH') => {
  // Ensure currency is always a valid uppercase string
  const curr = (currency ? String(currency).toUpperCase() : 'GHS') || 'GHS';
  const loc = locale || 'en-GH';
  
  return new Intl.NumberFormat(loc, {
    style: 'currency',
    currency: curr,
    minimumFractionDigits: 2
  }).format(amount || 0);
};

export const getCurrencySymbol = (currency) => {
  // Ensure currency is uppercase for comparison
  const curr = currency ? String(currency).toUpperCase() : 'GHS';
  const symbols = {
    'GHS': '₵',
    'USD': '$',
    'LRD': 'L$'
  };
  return symbols[curr] || (curr || '₵');
};

// Get currency from school details (always returns uppercase string)
export const getCurrencyFromSchool = (schooldetails) => {
  if (schooldetails && schooldetails.length > 0 && schooldetails[0]) {
    // First priority: Use currency field from database
    if (schooldetails[0].currency && String(schooldetails[0].currency).trim()) {
      return String(schooldetails[0].currency).trim().toUpperCase();
    }
    // Second priority: Derive from country
    if (schooldetails[0].country === 'LR') {
      return 'USD';
    }
  }
  // Default to GHS (always uppercase)
  return 'GHS';
};

// Get currency symbol from school details
export const getCurrencySymbolFromSchool = (schooldetails) => {
  const currency = getCurrencyFromSchool(schooldetails);
  return getCurrencySymbol(currency);
};

// Enhanced formatCurrency that auto-detects from school details
export const formatCurrencyWithSchool = (amount, schooldetails) => {
  const currency = getCurrencyFromSchool(schooldetails);
  const locale = schooldetails && schooldetails.length > 0 && schooldetails[0]?.locale 
    ? schooldetails[0].locale 
    : (currency === 'USD' ? 'en-US' : 'en-GH');
  
  return formatCurrency(amount, currency, locale);
};

export const formatPhoneNumber = (phone, countryCode = 'GH') => {
  if (!phone) return '';
  const cleaned = phone.replace(/\D/g, '');
  
  if (countryCode === 'GH') {
    if (cleaned.startsWith('233')) {
      return `+${cleaned}`;
    } else if (cleaned.startsWith('0')) {
      return `+233${cleaned.substring(1)}`;
    }
    return `+233${cleaned}`;
  } else if (countryCode === 'LR') {
    if (cleaned.startsWith('231')) {
      return `+${cleaned}`;
    } else if (cleaned.startsWith('0')) {
      return `+231${cleaned.substring(1)}`;
    }
    return `+231${cleaned}`;
  }
  
  return phone;
};




